import { BELTKIT_ANALYTICS_CATEGORY } from "@hermes/fragments/product-utils";
import {
    CallToActionAnalyticsEvent,
    GTMEventData,
} from "@hermes/fragments/analytics";

import { SIZE_GUIDE_ACTION_NAME } from "../constants/beltkit-analytics.constants";

/**
 * Analytics event triggered when the size guide tray is opened
 * from the personalized product page.
 */
export class OpenSizeGuideTrayClickEvent extends CallToActionAnalyticsEvent {
    /**
     * Overload formatForGTM of inherited class
     * Return formatter for eventaction and eventlabel key
     */
    public override formatForGTM(): GTMEventData {
        return {
            ...super.formatForGTM(),
            eventcategory: BELTKIT_ANALYTICS_CATEGORY, // BeltkitPerso is the only product with a size guide
            eventaction: SIZE_GUIDE_ACTION_NAME,
        };
    }
}
